import { render } from "./CompareColumns.vue?vue&type=template&id=a0eeadd8&scoped=true&ts=true"
import script from "./CompareColumns.vue?vue&type=script&lang=ts"
export * from "./CompareColumns.vue?vue&type=script&lang=ts"

import "./CompareColumns.vue?vue&type=style&index=0&id=a0eeadd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0eeadd8"]])

export default __exports__